export const applyPendingAffiliateDisplayUser = (user, person) => {
  if (!person?.pendingAffiliate) return user

  return { ...user, type: "PF", pendingAffiliate: true }
}
